import React, { useState, useEffect } from 'react';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import ReportsList from '../components/dashboard/ReportsList';
import CreditsIndicator from '../components/dashboard/CreditsIndicator';
import { useReports } from '../hooks/useReports';

export default function Reports() {
  const { reports, loading, error } = useReports();
  const [localReports, setLocalReports] = useState(reports);

  useEffect(() => {
    setLocalReports(reports);
  }, [reports]);

  return (
    <DashboardLayout>
      <div className="p-6">
        <div className="mb-8">
          <CreditsIndicator />
        </div>

        <div>
          <h2 className="text-xl font-bold text-gray-900 mb-4">Your Reports</h2>
          <p className="text-sm bg-blue-50 p-4 rounded-md text-gray-500 mb-4">
            Reports typically take 1-2 minutes to complete. You will get an email when it is ready. Click refresh on the browser to update the status.
            If an error occurs, we get notified and will look into it. We will get back to you within 1-business day.
          </p>
          <ReportsList reports={localReports} loading={loading} error={error} />
        </div>
      </div>
    </DashboardLayout>
  );
} 